import script from "./ModalExportError.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalExportError.vue?vue&type=script&setup=true&lang=ts"

import "./ModalExportError.vue?vue&type=style&index=0&id=7fe4be7c&lang=scss"

const __exports__ = script;

export default __exports__